<template>
  <div id="top">
    <div class="main-visual">
      <img
        src="/assets/img/sample.jpg"
        alt="マンション外観"
        class="mansion-image"
      />
    </div>

    <div class="main">
      <!-- 総会のご案内 -->
      <MeetingSummary mode="def" v-if="isPermission('OwnedNonResident')" />

      <!-- マンションのお知らせ -->
      <InfoList />

      <!--/.main-section-->
      <IconMenu />

      <!--/.main-section-->
    </div>
    <!--/.main-->
  </div>
</template>

<script>
import InfoList from "@/components/InfoList.vue";
import MeetingSummary from "@/components/MeetingSummary.vue";
import IconMenu from "@/components/IconMenu.vue";
export default {
  title: "トップ",
  components: { InfoList, MeetingSummary, IconMenu },
};
</script>

<style></style>
